import { render, staticRenderFns } from "./AdminWhitelistEditForm.vue?vue&type=template&id=5a5b701b&scoped=true"
import script from "./AdminWhitelistEditForm.vue?vue&type=script&lang=js"
export * from "./AdminWhitelistEditForm.vue?vue&type=script&lang=js"
import style0 from "./AdminWhitelistEditForm.vue?vue&type=style&index=0&id=5a5b701b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a5b701b",
  null
  
)

export default component.exports